import { Controller } from "@hotwired/stimulus";

// A collapsible order section on the redesigned realtime order page (#8790).
//
// Rules (owner, 2026-07-23 — supersedes the earlier "header freely toggles"
// rule): the page is a sequential accordion. Only the current step is open;
// a section stays LOCKED until every prior step has a selection, and satisfying
// a step collapses it and opens the next. The realtime-order controller owns
// that orchestration (lock/unlock/expand/collapse below); this controller owns
// a single section's own collapse + completed-badge state. The status badge
// shows the step label ("Step N", falling back to Required/Optional) until
// completed, then the green "Completed" pill.
export default class extends Controller {
  static targets = ["body", "badge", "chevron", "completed"];
  static values = { required: Boolean, stepLabel: String };

  // Header click/enter. Locked sections do not open — the realtime-order
  // orchestrator sets/removes is-locked as prior steps are satisfied.
  toggle() {
    if (this.isLocked) return;
    this.element.classList.toggle("is-collapsed");
  }

  get isLocked() {
    return this.element.classList.contains("is-locked");
  }

  toggleCompleted() {
    const done = this.completedTarget.checked;
    this.element.classList.toggle("is-completed", done);
    this.element.classList.toggle("is-collapsed", done);
    this.updateBadge(done);
    // Let the page controller recompute order progress + the Add to Cart gate,
    // and validate section-specific rules (e.g. Order Options needs states/days).
    this.dispatch("completedChanged", {
      bubbles: true,
      detail: { completed: done, key: this.element.dataset.rloSectionKey },
    });
  }

  updateBadge(done) {
    if (!this.hasBadgeTarget) return;
    if (done) {
      this.badgeTarget.textContent = "Completed";
      this.badgeTarget.dataset.state = "done";
    } else {
      this.badgeTarget.textContent =
        this.stepLabelValue || (this.requiredValue ? "Required" : "Optional");
      this.badgeTarget.dataset.state = this.requiredValue ? "required" : "optional";
    }
  }

  get isCompleted() {
    return this.hasCompletedTarget && this.completedTarget.checked;
  }

  get isCollapsed() {
    return this.element.classList.contains("is-collapsed");
  }
}
